// The guided tour of the SLT Register, for the Senior Leadership Team meeting
// it for the first time.
//
// Steps point at [data-tour] anchors on SltRegisterPage, in the order the page
// reads. The HR step is gated on `canHr`, the same fact the page draws the HR
// filter and the HR mark from.

export const SLT_REGISTER_TOUR_ID = 'slt-register';

export const sltRegisterTourSteps = [
  {
    title: 'Welcome to the SLT Register',
    target: '[data-tour="page-header"]',
    body: [
      'Risks, issues and actions for the Senior Leadership Team. Only the SLT can open this page, and nothing on it appears anywhere else: not in the RAID Register, search, project updates, reports, the Actions queue or the Claude connector.',
      'Use Next (or the arrow keys) to walk through, or Skip. It will not pop up again, and the ? button replays it.',
    ],
  },
  {
    title: 'Raise an item',
    target: '[data-tour="new-item"]',
    body: [
      'Raise a risk, an issue or an action. Risks and issues take a probability and impact from 1 to 5, and actions take a due date. The owner can be anyone on the SLT.',
      'To raise an action against a risk or issue, open that item and use Add action.',
    ],
  },
  {
    title: 'Find what you need',
    target: '[data-tour="filters"]',
    body: [
      'Filter by type, tick Mine for the items you own, and tick Show closed to see completed actions and closed items. Search looks at the reference, title and description.',
    ],
  },
  {
    title: 'HR confidential items',
    target: '[data-tour="hr-filter"]',
    when: (c) => c.canHr,
    body: [
      'You hold the HR tier, so you can mark an item HR confidential. Only people on the HR tier see it: the rest of the SLT do not know it exists, and holding admin does not change that.',
      'Actions raised against an HR item are HR too. HR items are always owned by someone on the HR tier.',
    ],
  },
  {
    title: 'The risk matrix',
    target: '[data-tour="matrix"]',
    body: [
      'Open risks placed by probability and impact. Issues and actions are not on it, since an issue has already happened. It follows the search box and the Mine and HR filters, so it always matches the table below.',
    ],
  },
  {
    title: 'The register',
    target: '[data-tour="table"]',
    body: [
      'Open items first, highest score first. Click a row to amend it, complete an action or close a risk or issue. Anyone on the SLT can do any of these.',
      'Nobody is emailed and nothing reaches My Actions. Instead, the SLT Register link in the sidebar shows how many open actions you own, in red once any is overdue. It names no item.',
    ],
  },
];
